import type { TimetableEntry } from '../types/timetable';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.ilmhub.uz';

export const fetchTimetable = async (): Promise<TimetableEntry[]> => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/timetable`);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching timetable:', error);
    return [];
  }
};
